// FutureLab
import { feedbackFormSlice } from '../store/slices/feedbackSlice';

export const feedbackFormInFocus = feedbackFormSlice.reducer;
